export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20abstract%20geometric%20composition%20with%20soft%20overlapping%20circles%20and%20flowing%20organic%20shapes%2C%20creamy%20beige%20and%20warm%20terracotta%20tones%2C%20gentle%20gradients%2C%20minimalist%20modern%20art%20style%2C%20elegant%20and%20sophisticated%20background%2C%20soft%20diffused%20lighting%2C%20luxurious%20texture&width=1600&height=900&seq=hero-bg-main&orientation=landscape"
          alt="今日看料背景"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/45"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-[1200px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-accent-500/90 text-background-50 text-xs md:text-sm font-medium tracking-wide mb-4 md:mb-5">
              每日精选推荐
            </span>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-background-50 leading-tight mb-3 md:mb-4">
              今日看料：美好生活从今日开始
            </h1>

            <p className="text-lg md:text-xl text-background-100/90 font-heading mb-6 md:mb-7">
              热门话题与生活妙招，一网打尽
            </p>

            <p className="text-sm md:text-base text-background-200/90 leading-relaxed max-w-[580px] mx-auto lg:mx-0 mb-8">
              今日看料美好生活专栏每日清晨准时更新，从海量生活资讯中精心筛选最有价值的精选内容。无论是居家收纳的巧思、厨房烹饪的秘诀，还是健康养生的智慧、旅行出游的灵感——这里汇聚了让每一天变得更美好的实用妙招与热门话题。编辑团队全年无休，用原创与精选为你的生活增添新鲜料。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">1860+</div>
                <div className="text-xs md:text-sm text-background-300/80 mt-1">原创精选内容</div>
              </div>
              <div className="w-px h-10 bg-background-300/30 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">50万+</div>
                <div className="text-xs md:text-sm text-background-300/80 mt-1">月活读者信赖</div>
              </div>
              <div className="w-px h-10 bg-background-300/30 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">365天</div>
                <div className="text-xs md:text-sm text-background-300/80 mt-1">全年不间断更新</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#features"
                className="w-full sm:w-auto px-8 py-3 rounded-lg bg-primary-500 text-background-50 text-sm md:text-base font-medium hover:bg-primary-600 transition-colors duration-200 text-center whitespace-nowrap cursor-pointer"
              >
                开始探索
              </a>
              <a
                href="#about"
                className="w-full sm:w-auto px-8 py-3 rounded-lg border border-background-300/50 text-background-100 text-sm md:text-base font-medium hover:bg-background-50/10 transition-colors duration-200 text-center whitespace-nowrap cursor-pointer"
              >
                了解更多
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[460px]">
              <div className="aspect-[4/3] rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Warm%20cozy%20reading%20nook%20with%20wooden%20desk%2C%20open%20magazine%20and%20coffee%20cup%2C%20morning%20sunlight%20streaming%20through%20window%2C%20indoor%20plants%2C%20soft%20textiles%2C%20minimalist%20Scandinavian%20style%2C%20peaceful%20atmosphere%2C%20editorial%20lifestyle%20photography%2C%20warm%20neutral%20color%20palette&width=920&height=690&seq=hero-visual-main&orientation=landscape"
                  alt="今日看料 - 美好生活从今日开始"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute -bottom-3 -left-3 bg-background-50 rounded-xl px-4 py-3">
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 rounded-full bg-green-500"></div>
                  <span className="text-xs text-foreground-700 font-medium whitespace-nowrap">今日已更新 6 篇精选</span>
                </div>
              </div>
              <div className="absolute -top-3 -right-3 bg-accent-500 rounded-xl px-4 py-3">
                <div className="flex items-center gap-2">
                  <i className="ri-fire-line text-background-50"></i>
                  <span className="text-xs text-background-50 font-medium whitespace-nowrap">本周热门榜单</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}